import React from "react";
import { FaWpforms, FaFileAlt, FaCheckCircle } from "react-icons/fa";
import "./Admission.css";

export default function Admission() {
  const steps = [
    {
      num: "1",
      title: "Fill the Application Form",
      text: "Submit your basic details and preferred course through our online admission form.",
      icon: <FaWpforms size={50} />, // form icon
    },
    {
      num: "2",
      title: "Document Verification",
      text: "Upload scanned copies of required documents for verification by our admission team.",
      icon: <FaFileAlt size={50} />, // document icon
    },
    {
      num: "3",
      title: "Confirm Admission & Pay Fees",
      text: "Confirm your admission and pay fees securely to complete the enrollment process.",
      icon: <FaCheckCircle size={50} />, // confirmation/payment icon
    },
  ];

  return (
    <div>
      <div className="process-wrapper">
        <h1 className="text-center mb-5">Our Admission Process</h1>
        <div className="process-container">
          {steps.map((s) => (
            <div key={s.num} className="process-step">
              <div className="step-icon">{s.icon}</div>

              <div className="step-number">{s.num}</div>
              <h3 className="step-title">{s.title}</h3>
              <p className="step-text">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
